import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import tr from "./locales/tr.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import ru from "./locales/ru.json";
import trPages from "./locales/tr_pages.json";
import enPages from "./locales/en_pages.json";
import arPages from "./locales/ar_pages.json";
import ruPages from "./locales/ru_pages.json";

const SUPPORTED_LANGS = ["tr", "en", "ar", "ru"];

/**
 * Dil bazlı URL slug haritası.
 * Her sayfa için her dilin kendi slug'ı tanımlıdır.
 */
const ROUTE_SLUGS = {
  about: { tr: "hakkimizda", en: "about", ar: "hawlana", ru: "o-nas" },
};

/**
 * Slug'dan route key'ini bulur (reverse lookup).
 * Örn: "hakkimizda" → "about"
 */
function getRouteKeyFromSlug(slug) {
  for (const [routeKey, slugMap] of Object.entries(ROUTE_SLUGS)) {
    for (const langSlug of Object.values(slugMap)) {
      if (langSlug === slug) return routeKey;
    }
  }
  return null;
}

/**
 * Belirli bir route key ve dil için localize edilmiş slug döndürür.
 * Örn: getLocalizedSlug("about", "tr") → "hakkimizda"
 */
export function getLocalizedSlug(routeKey, lang) {
  const slugMap = ROUTE_SLUGS[routeKey];
  if (slugMap && slugMap[lang]) return slugMap[lang];
  return routeKey; // fallback: orijinal key'i döndür
}

/**
 * Belirli bir route key ve dil için tam path döndürür.
 * Örn: getLocalizedPath("about", "tr") → "/tr/hakkimizda"
 */
export function getLocalizedPath(routeKey, lang) {
  return `/${lang}/${getLocalizedSlug(routeKey, lang)}`;
}

/**
 * Tüm diller için belirli bir route key'in tüm slug'larını döndürür.
 * React Router'da birden fazla path tanımlamak için kullanılır.
 */
export function getAllSlugsForRoute(routeKey) {
  const slugMap = ROUTE_SLUGS[routeKey];
  if (!slugMap) return [routeKey];
  return [...new Set(Object.values(slugMap))];
}

/**
 * Mevcut URL path'indeki slug'ı yeni dile çevirir.
 * Örn: translatePathToLang("/tr/hakkimizda", "en") → "/en/about"
 */
export function translatePathToLang(pathname, newLang) {
  const parts = pathname.split("/");
  if (parts.length < 3) {
    parts[1] = newLang;
    return parts.join("/");
  }
  const currentSlug = parts[2];
  const routeKey = getRouteKeyFromSlug(currentSlug);
  parts[1] = newLang;
  if (routeKey) {
    parts[2] = getLocalizedSlug(routeKey, newLang);
  }
  return parts.join("/");
}

function getInitialLang() {
  const pathLang = window.location.pathname.split("/")[1];
  if (SUPPORTED_LANGS.includes(pathLang)) return pathLang;
  const stored = localStorage.getItem("oly_lang");
  if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  return "tr";
}

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: { ...tr, ...trPages } },
    en: { translation: { ...en, ...enPages } },
    ar: { translation: { ...ar, ...arPages } },
    ru: { translation: { ...ru, ...ruPages } },
  },
  lng: getInitialLang(),
  fallbackLng: "tr",
  interpolation: { escapeValue: false },
});

export const LANGUAGES = [
  { code: "tr", label: "TR", name: "Turkce", flag: "\uD83C\uDDF9\uD83C\uDDF7" },
  { code: "en", label: "EN", name: "English", flag: "\uD83C\uDDEC\uD83C\uDDE7" },
  { code: "ar", label: "AR", name: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629", flag: "\uD83C\uDDF8\uD83C\uDDE6" },
  { code: "ru", label: "RU", name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439", flag: "\uD83C\uDDF7\uD83C\uDDFA" },
];

export const isRTL = (lang) => lang === "ar";

export default i18n;
